(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function money(cents, currency) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: currency || 'NGN'
      });
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function initPdp(root) {
    if (!root || root.dataset.wxPdpReady === '1') return;
    root.dataset.wxPdpReady = '1';

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-wx-thumb]'));
    var shots = Array.prototype.slice.call(root.querySelectorAll('[data-wx-shot]'));

    function setActiveThumb(id) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-target') === id);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        var targetId = thumb.getAttribute('data-target');
        var shot = targetId && document.getElementById(targetId);
        if (!shot) return;
        e.preventDefault();
        shot.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActiveThumb(targetId);
      });
    });

    if ('IntersectionObserver' in window && shots.length && thumbs.length) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            setActiveThumb(entry.target.id);
          });
        },
        { root: null, threshold: 0.55, rootMargin: '-20% 0px -35% 0px' }
      );
      shots.forEach(function (shot) { io.observe(shot); });
    }

    var qtyWrap = root.querySelector('[data-wx-qty]');
    if (qtyWrap) {
      var input = qtyWrap.querySelector('input');
      var minus = qtyWrap.querySelector('[name="minus"]');
      var plus = qtyWrap.querySelector('[name="plus"]');
      if (minus) {
        minus.addEventListener('click', function () {
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        });
      }
      if (plus) {
        plus.addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 1) + 1;
        });
      }
    }

    var variantsEl = root.querySelector('[data-wx-variants]');
    var variantInput = root.querySelector('[data-wx-variant-id]');
    var atc = root.querySelector('[data-wx-atc]');
    var priceEl = root.querySelector('[data-wx-price]');
    var stockEl = root.querySelector('[data-wx-stock]');
    var stockQty = root.querySelector('[data-wx-stock-qty]');
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'NGN';
    var stockThreshold = 10;

    if (variantsEl && variantInput) {
      var variants = [];
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (e) {
        variants = [];
      }

      function selectedOptions() {
        var opts = [];
        root.querySelectorAll('.wx-pdp__option').forEach(function (group) {
          var sel = group.querySelector('.wx-pdp__pill.is-selected');
          opts.push(sel ? sel.getAttribute('data-value') : null);
        });
        return opts;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) {
            return o === opts[i];
          });
        });
      }

      root.querySelectorAll('[data-wx-option]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('.wx-pdp__option');
          group.querySelectorAll('[data-wx-option]').forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');

          var valueLabel = group.querySelector('[data-wx-option-value]');
          if (valueLabel) valueLabel.textContent = btn.getAttribute('data-value');

          var variant = findVariant(selectedOptions());
          if (!variant) return;

          variantInput.value = variant.id;

          if (atc) {
            atc.disabled = !variant.available;
            atc.textContent = variant.available ? (atc.dataset.label || 'Add to cart') : 'Sold out';
          }

          if (priceEl) {
            var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
            priceEl.innerHTML =
              '<span class="wx-pdp__price' +
              (onSale ? ' is-sale' : '') +
              '">' +
              money(variant.price, currency) +
              '</span>' +
              (onSale
                ? '<span class="wx-pdp__compare">' + money(variant.compare_at_price, currency) + '</span>'
                : '');
          }

          if (stockEl && stockQty) {
            var qty = variant.inventory_quantity;
            var show =
              variant.available &&
              typeof qty === 'number' &&
              qty > 0 &&
              qty <= stockThreshold;
            stockQty.textContent = qty;
            stockEl.classList.toggle('is-hidden', !show);
          }
        });
      });

      if (atc) atc.dataset.label = atc.textContent.trim();
    }

    var flash = root.querySelector('[data-wx-countdown]');
    if (flash) {
      var endStr = flash.getAttribute('data-end');
      var end = endStr ? new Date(endStr) : null;
      if (!end || isNaN(end.getTime())) {
        end = new Date(Date.now() + 12 * 60 * 60 * 1000);
      }

      var hoursEl = flash.querySelector('[data-hours]');
      var minsEl = flash.querySelector('[data-mins]');
      var secsEl = flash.querySelector('[data-secs]');
      var csEl = flash.querySelector('[data-cs]');

      function tick() {
        var diff = Math.max(0, end.getTime() - Date.now());
        var totalSec = Math.floor(diff / 1000);
        var h = Math.floor(totalSec / 3600);
        var m = Math.floor((totalSec % 3600) / 60);
        var s = totalSec % 60;
        var cs = Math.floor((diff % 1000) / 10);
        if (hoursEl) hoursEl.textContent = pad(h);
        if (minsEl) minsEl.textContent = pad(m);
        if (secsEl) secsEl.textContent = pad(s);
        if (csEl) csEl.textContent = pad(cs);
      }

      tick();
      setInterval(tick, 50);
    }
  }

  function boot() {
    document.querySelectorAll('[data-wx-pdp]').forEach(initPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-wx-pdp]');
    if (root) {
      delete root.dataset.wxPdpReady;
      initPdp(root);
    }
  });
})();
